var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf06W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vectorsolutons-2",
    d: "M0,1.306V15.694A1.289,1.289,0,0,0,1.261,17H22.739A1.289,1.289,0,0,0,24,15.694V1.306A1.289,1.289,0,0,0,22.739,0H1.261A1.282,1.282,0,0,0,0,1.306ZM4.082,8.5h8.982a.656.656,0,0,1,0,1.312H4.082a.656.656,0,0,1,0-1.312Zm3.449,4.574H4.082a.656.656,0,0,1,0-1.312H7.531a.656.656,0,0,1,0,1.312Zm12.393,0H10.942a.656.656,0,0,1,0-1.312h8.982a.656.656,0,0,1,0,1.312Zm0-3.262H16.475a.656.656,0,0,1,0-1.312h3.449a.656.656,0,0,1,0,1.312Z",
    transform: "translate(13 16.176)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf06W);
export default __webpack_public_path__ + "static/media/icon-wf-06-w.3b5afb8e1521adbc4771f6ee5e976027.svg";
export { ForwardRef as ReactComponent };